import React, { useEffect, useRef, useState } from "react";
import { Grid, Paper, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print";

import { selectMaterialPOReg } from "../../Selectors/Master/OutwardSelectors";
import { fetchMaterialPOReg } from "../../../Store/PHPSlice/Purchase/PoNo";

const MaterialPOViewNew = () => {

  const { Id } = useParams();
  const dispatch = useDispatch();
  const polist = useSelector(selectMaterialPOReg);

  const [formData, setFormData] = useState({});
  const componentRef = useRef();

  useEffect(() => {
    dispatch(fetchMaterialPOReg(Id));
  }, [dispatch, Id]);

  useEffect(() => {
    if (polist?.data) {
      setFormData(polist.data);
    }
  }, [polist]);
const numberToWords = (num) => {
  const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
  const b = ['', '', 'Twenty ', 'Thirty ', 'Forty ', 'Fifty ', 'Sixty ', 'Seventy ', 'Eighty ', 'Ninety '];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + a[n % 10];
    if (n < 1000) return a[Math.floor(n / 100)] + 'Hundred ' + inWords(n % 100);
    if (n < 100000) return inWords(Math.floor(n / 1000)) + 'Thousand ' + inWords(n % 1000);
    if (n < 10000000) return inWords(Math.floor(n / 100000)) + 'Lakh ' + inWords(n % 100000);
    return '';
  };

  return inWords(num) + 'Rupees Only';
};
const thStyle = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  fontSize:"11px",
  fontWeight:"bold",
};

const tdCenter = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center"
};

const tdLeft = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "left"
};

const tdRight = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "right"
};
  return (
    <>
      <Grid item xs={12}>
        <Paper style={{ padding: "20px" }}>

          <div ref={componentRef} style={{ width: "800px", margin: "auto", background: "#fff", padding: "15px", border: "1px solid #000" }}>

            {/* HEADER */}
<div style={{ textAlign: "center", marginBottom: "10px" }}>
  <h2 style={{ margin: 0 }}>TAX INVOICE</h2>
</div>
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
              <tbody>

                <tr>
                  <td align="left" style={{ width: "60%", border: "1px solid black", padding: "5px" }}>
                    <h4 style={{color:"blue",marginBottom:"5px"}}>{formData.partyNm}</h4><br />
                   <b>Address :</b>{formData.partyAddress}<br />
                   <b>State :</b>{formData.partyState} <b>State Code :</b>{formData.partystatecd}<br />
                    <b>GST No :</b>{formData.partyGst}<br/>
                    <b>PAN No :</b>{formData.partyPan}<br/>
                    <b>Email:</b>{formData.partyemail}<br/>
                    <b>Contact :</b>{formData.partycontact}
                  </td>

                  <td style={{ width: "40%", border: "1 px solid black", padding: "5px" }}>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{borderleft:"1px solid #fff"}}><b>PO No</b></td>
                          <td><b>{formData.pono}</b></td>
                        </tr>

                        <tr>
                          <td><b>Date</b></td>
                          <td>{formData.date}</td>
                        </tr>
                         <tr>
                          <td><b>Shift To</b></td>
                          <td>{formData.shifto}</td>
                        </tr>
                        <tr>
                          <td><b>Reference</b></td>
                          <td>{formData.refer}</td>
                        </tr>

                      </tbody>
                    </table>
                  </td>
                </tr>

              </tbody>
            </table>


            {/* BUYER DETAILS */}

            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
              <tbody>

                <tr>

                  <td style={{ width: "60%", border: "1px solid black", padding: "5px" }}>
                    <h4 style={{color:"black"}}>{formData.firmNm}(Bill To)</h4><br />
                   <b>Address :</b>{formData.firmadd}<br />
                    <b>GST No :</b>{formData.firmgst}<br/>
                    <b>PAN No :</b>{formData.firmpan}<br/>
                    <b>Email:</b>{formData.firmemail}<br/>
                    <b>Contact :</b>{formData.firmcontact}
                  </td>

                  <td  valign="top" style={{ width: "40%", borderbottom: "1px solid white", padding: "5px" }}>
                   <b>Terms of Delivery</b>
                  </td>

                </tr>

              </tbody>
            </table>


            {/* ITEM TABLE */}

          <table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "12px",
    tableLayout: "fixed"
  }}
>
  <thead>
    <tr style={{ backgroundColor: "#e6e6e6" }}>
      <th style={thStyle}>Sr</th>
      <th style={thStyle}>Material</th>
      <th style={thStyle}>Pkt Qty</th>
      <th style={thStyle}>Per Packet</th>
      <th style={thStyle}>Delivery</th>
      <th style={thStyle}>Rate</th>
      <th style={thStyle}>Qty</th>
      <th style={thStyle}>Mtr</th>
      <th style={thStyle}>Inch</th>
      <th style={thStyle}>Tot Qty</th>
      <th style={thStyle}>Amount</th>
      <th style={thStyle}>IGST</th>
      <th style={thStyle}>CGST</th>
      <th style={thStyle}>SGST</th>
    </tr>
  </thead>

  <tbody>
    {polist?.info?.map((row, index) => (
      <tr key={index}>
        <td style={tdCenter}>{index + 1}</td>
        <td style={tdLeft}>{row.materialNm}</td>
        <td style={tdCenter}>{row.pktqty} {row.mtype}</td>
        <td style={tdCenter}>{row.perpacket} {row.ptype}</td>
        <td style={tdCenter}>{row.deldt}</td>
        <td style={tdRight}>{row.rate}</td>
        <td style={tdRight}>{row.qty}</td>
        <td style={tdRight}>{row.mtr}</td>
        <td style={tdRight}>{row.inches}</td>
        <td style={tdRight}>{row.totqty}</td>
        <td style={tdRight}>{row.amt}</td>
        <td style={tdRight}>{row.igstamt} ({row.igst}%)</td>
        <td style={tdRight}>{row.cgstamt} ({row.cgst}%)</td>
        <td style={tdRight}>{row.sgstamt} ({row.sgst}%)</td>
      </tr>
    ))}
  </tbody>
</table>


            {/* TOTAL SECTION */}

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>

              <tbody>

                <tr>
                  <td style={{ border: "1px solid black", padding: "5px" }}><b style={{color:"blue"}}>Total Qty</b></td>
                  <td style={{ border: "1px solid black", padding: "5px" }}><b style={{color:"blue"}}>{formData.totqty}</b></td>
                   <td style={{ border: "1px solid black", padding: "5px" }}><b>Total Amount</b></td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>{formData.amt}</td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid black", padding: "5px" }}><b>Tax Amount</b></td>
                  <td style={{ border: "1px solid black", padding: "5px" }}>{formData.taxamt}</td>
                   <td style={{ border: "1px solid black", padding: "5px" }}><b style={{color:"blue"}}>Final Amount</b></td>
                  <td style={{ border: "1px solid black", padding: "5px" }}><b style={{color:"blue"}}>{formData.finalamt}</b></td>
                </tr>
                    <td colSpan={4}>
<div style={{ marginTop: "10px", fontWeight: "bold" }}>
  <b>Total Amount In Words : {numberToWords(Number(formData.finalamt || 0))}</b>
</div>

                    </td>
                <tr>
                 
                </tr>

                <tr>
                 
                </tr>

              </tbody>

            </table>


            {/* FOOTER */}

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "15px" }}>

              <tbody>

                <tr>

                  <td style={{ width: "60%", border: "1px solid black", padding: "5px" }}>
                    <b>Declaration</b><br />
                    We declare that this purchase order shows the actual price of goods.
                  </td>

                  <td style={{ width: "40%", border: "1px solid black", padding: "5px", textAlign: "center" }}>
                    For <b>{formData.partyNm}</b><br /><br /><br />
                    Authorised Signatory
                  </td>

                </tr>

              </tbody>

            </table>

          </div>


          {/* PRINT BUTTON */}

          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <ReactToPrint
              trigger={() => (
                <Button variant="contained" color="primary">
                  Print
                </Button>
              )}
              content={() => componentRef.current}
            />
          </div>

        </Paper>
      </Grid>
    </>
  );
};

export default MaterialPOViewNew;